import { InjectionToken, SkipSelf } from '@angular/core';

import type { Provider } from '@angular/core';
import type { FormControl, NgModel } from '@angular/forms';

type ValidationMessages = Record<
  string,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (errorDetails: any, ctrl: FormControl | NgModel) => string
>;

const VALIDATION_MESSAGES = new InjectionToken<Array<ValidationMessages>>(
  'VALIDATION_MESSAGES',
);

const messageFactory =
  (messages: ValidationMessages) =>
  (msgs: Array<ValidationMessages>): Array<ValidationMessages> => [
    ...msgs,
    messages,
  ];

/**
 * Adds a validation message provider to the application.
 * @param messages - The validation messages to be provided.
 * @returns A provider object that can be used to add the validation messages.
 */
function addValidationMessage(messages: ValidationMessages): Provider {
  return {
    deps: [[new SkipSelf(), VALIDATION_MESSAGES]],
    multi: true,
    provide: VALIDATION_MESSAGES,
    useFactory: messageFactory(messages),
  };
}

export type { ValidationMessages };
export { addValidationMessage, VALIDATION_MESSAGES };
